// src/components/UserMeet/layouts/StageLayoutTable.jsx
import React from "react";
import NatureTable from "../../../pages/MeetingRoom/ui/NatureTable";
import Seat from "../../../pages/MeetingRoom/ui/Seat";
import Icon from "../../../pages/MeetingRoom/ui/Icon";

/** Head-seat indices that get the gold ring accent */
const HEAD_SEAT_INDICES = {
  6: new Set([2, 5]), // HeadRight = index 2, HeadLeft = index 5
  10: new Set([4, 9]), // HeadRight = index 4, HeadLeft = index 9
};

/** Map capacity → NatureTable shape prop */
const TABLE_SHAPE = {
  4: "square",
  6: "rect-6",
  10: "rect-10",
};

export default function StageLayoutTable({
  capacity,
  seats,
  seatPositions,
  overflowCount,
  meetingTitle,
  screenShareTrack,
  onAvatarPress,
  onNamePress,
  onLike,
  onShowNetworking,
}) {
  const tableSize =
    capacity <= 4
      ? "jt-stage--size4"
      : capacity <= 6
        ? "jt-stage--size6"
        : "jt-stage--size10";

  const headIndices = HEAD_SEAT_INDICES[capacity] ?? new Set();
  const tableShape = TABLE_SHAPE[capacity] ?? "square";

  return (
    <div
      className={`jt-stage ${tableSize} ${screenShareTrack ? "jt-stage-hidden" : ""}`}
    >
      {/* ── Table ── */}
      <div className="jt-tableCenter">
        <NatureTable
          tableName={meetingTitle}
          tableIcon={null}
          onPressSponsor={null}
          shape={tableShape}
        />
      </div>

      {/* ── Seats ── */}
      {seats.map((p, i) => {
        if (i >= seatPositions.length) return null;
        return (
          <Seat
            key={`seat-${i}`}
            seatIndex={i}
            pos={seatPositions[i]}
            participant={p}
            onAvatarPress={(participant) => {
              if (!participant) return;
              onAvatarPress?.(participant);
            }}
            onNamePress={onNamePress}
            onLike={(toUserId) => onLike?.(toUserId)}
            onShowNetworking={onShowNetworking}
            isHeadSeat={headIndices.has(i)}
          />
        );
      })}

      {/* ── Overflow badge ── */}
      {overflowCount > 0 && (
        <div className="jt-overflowBadge" title="More participants">
          <Icon name="people" />
          <span>+{overflowCount} more</span>
        </div>
      )}
    </div>
  );
}
